<template>
  <div class="externalContainer">
    <leftPublicTree type="external" :updatePersonList="updatePersonList"></leftPublicTree>
    <rightPublicTable type="external" ref="rightPublicTable"></rightPublicTable>
  </div>
</template>

<script>
import leftPublicTree from '../components/leftPublicTree'
import rightPublicTable from '../components/rightPublicTable'
export default {
  name:'external',

  components : {
    leftPublicTree,
    rightPublicTable
  },

  methods : {
    updatePersonList (data) {
      this.$refs.rightPublicTable.updateList(data)
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .externalContainer
    width 100%
    height 100%
    margin-top 14px
    display flex
    align-items center
    background #fff
</style>
